$(function() {
  let currentMenuId;
  let background = $('#background_menu_open');

  /*Display only the right menu*/
  $('#menu-vous-etes .icon-container').off('click').on('click', (e) => {
    e.preventDefault();

    let _main_link;
    if (e.target.classList.contains('icon-container')) {
      _main_link = $(e.target);
    } else {
      _main_link = $(e.target).parents('.icon-container');
    }

    if ($(_main_link).hasClass('icon-container-selected')) {
      let id = $(_main_link).attr('id');
      $('#navbar-vous-etes.'+id).addClass('d-none');
      $(_main_link).removeClass('icon-container-selected');
    } else {
      $('.vous-etes').addClass('d-none');
      $('#menu-vous-etes').find('.icon-container-selected').removeClass('icon-container-selected');
      if(!e.target.classList.contains('icon-container')) {
        $(e.target).closest('.icon-container').addClass('icon-container-selected');
        currentMenuId = '.'+$(e.target).closest('.icon-container').attr('id');
      } else {
        $(e.target).addClass('icon-container-selected');
        currentMenuId = '.'+e.target.id;
      }
      $(currentMenuId).removeClass('d-none');
      $(currentMenuId).addClass('d-block');
      /*background.fadeIn('fast');*/
    }


  });



  $('.close-menu-vous-etes').off('click').on('click', (e) => {
    $('.vous-etes').addClass('d-none');
    $('#menu-vous-etes').find('.icon-container-selected').removeClass('icon-container-selected');
  });

  $(document).off('click').on('click', (event) => {
    if ($(event.target).closest('#navbar-vous-etes').length === 0 && $(event.target).closest('.icon-container').length === 0) {
      $('#menu-vous-etes').find('.icon-container-selected').removeClass('icon-container-selected');
      $('.vous-etes').addClass('d-none');
      /*background.fadeOut('fast');*/
    }
  });

  /* GESTION DU MENU VOUS ETES MOBILE */
  // $('.mobile-vous-etes button.depth-0').off('click').on('click', (e) => {
  //   console.log('click2 !');
  //   /* RESET */
  //   $('.mobile-vous-etes ul').removeClass('show');
  //   $('.mobile-vous-etes li').removeClass('show');
  //   $('.mobile-vous-etes button').removeClass('toggle');
  //   /* DISPLAY */
  //   $(e.target).find('.hide').addClass('show');
  //
  //   $(e.target).addClass('toggle');
  // });

  $('.mobile-vous-etes button.depth-0 a').off('click').on('click', (el) => {
    $('.mobile-vous-etes ul').removeClass('show');
    $('.mobile-vous-etes li').removeClass('show');

    if(!$(el.target).parents('button.depth-0').hasClass('toggle')) {
      $('.mobile-vous-etes button').removeClass('toggle');
      /* DISPLAY */
      $(el.target).parents('button.depth-0').find('.hide').addClass('show');

      $(el.target).parents('button.depth-0').addClass('toggle');
    } else {
      $('.mobile-vous-etes button').removeClass('toggle');
    }



  });
});